import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
interface CategoryEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  category: {
    id: number;
    emoji: string;
    name: string;
  } | null;
  onSave: (emoji: string, name: string) => void;
}
const emojis = ['💪', '🏃', '❤️', '🏠', '🎨', '🎵', '🏃‍♀️', '🍎', '💰', '🎯', '⭐', '🌸', '🎓', '⚽', '📷', '🎬', '🏆', '🌍', '🎨', '🍕', '🎓', '🎮', '📸', '🎸', '🎨', '🎪', '🎭', '🎯', '🎲', '🎰', '🚀', '🎂'];
export function CategoryEditModal({
  isOpen,
  onClose,
  category,
  onSave
}: CategoryEditModalProps) {
  const [selectedEmoji, setSelectedEmoji] = useState('💪');
  const [categoryName, setCategoryName] = useState('');
  useEffect(() => {
    if (category) {
      setSelectedEmoji(category.emoji);
      setCategoryName(category.name);
    } else {
      setSelectedEmoji('💪');
      setCategoryName('');
    }
  }, [category, isOpen]);
  if (!isOpen) return null;
  const isEditing = category !== null;
  const modalTitle = isEditing ? 'Editar Categoria' : 'Cadastrar Categoria';
  const handleSave = () => {
    onSave(selectedEmoji, categoryName);
    onClose();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-20">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4" data-id="element-21">
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-22">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-23">{modalTitle}</h2>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-24">
            <X className="w-5 h-5" data-id="element-25" />
          </button>
        </div>
        <div className="p-6 space-y-6" data-id="element-26">
          <div data-id="element-27">
            <label className="block text-sm font-medium text-gray-900 mb-3" data-id="element-28">
              Escolha um emoji <span className="text-red-500" data-id="element-29">*</span>
            </label>
            <div className="grid grid-cols-8 gap-2 p-4 bg-gray-50 rounded-lg max-h-48 overflow-y-auto" data-id="element-30">
              {emojis.map(emoji => <button key={emoji} onClick={() => setSelectedEmoji(emoji)} className={`text-2xl p-2 rounded-lg transition-colors ${selectedEmoji === emoji ? 'bg-[#8BC4C3] ring-2 ring-[#2C4A6B]' : 'hover:bg-gray-200'}`} data-id="element-31">
                  {emoji}
                </button>)}
            </div>
          </div>
          <div data-id="element-32">
            <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-33">
              Nome da categoria <span className="text-red-500" data-id="element-34">*</span>
            </label>
            <input type="text" value={categoryName} onChange={e => setCategoryName(e.target.value)} placeholder="Ex: Educação" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent bg-gray-50" data-id="element-35" />
          </div>
        </div>
        <div className="flex gap-3 p-6 border-t border-gray-200" data-id="element-36">
          <button onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-37">
            Cancelar
          </button>
          <button onClick={handleSave} className="flex-1 px-4 py-2 bg-[#8BC4C3] text-white rounded-lg hover:bg-[#6BABA9] transition-colors" data-id="element-38">
            {isEditing ? 'Salvar Categoria' : 'Criar Categoria'}
          </button>
        </div>
      </div>
    </div>;
}